<template>
  <div class="pagination">
    <div class="numeration" v-if="total > 1">
      <span class="results">
        {{ (currentPage - 1) * itemsPerPage + 1 }} -
        {{ Math.min(itemsPerPage * currentPage, total) }} de
        {{ total }} Resultados
      </span>
      <span class="rows">Filas por página: </span>
      <FormField
        tag="select"
        name="items_perpage"
        title="Items por pagina"
        size="small"
        theme="normal"
        :value="itemsPerPage"
        :options="itemsPerPageForm"
        @getValue="updateItemsPerPage"
      />
      <!--
        <template v-for="(ippt, index) in itemsPerPageForm" :key="index">
          <option :value="ippt.value" :selected="itemsPerPage == ippt.value">
            {{ ippt.text }}
          </option>
        </template>
      </FormField>
      -->
    </div>
    <List tag="ol" horizontal class="pages-list" v-if="totalPages > 1">
      <li v-if="prevButton">
        <Button
          tag="button"
          @click="updateCurrentPage(currentPage - 1)"
          theme="text"
          rounded
        >
          <Icon svg="thinAngleLeft" theme="flat" />
        </Button>
      </li>
      <template v-for="(tag, index) in pages" :key="index">
        <li v-if="tag != '...' && tag != currentPage">
          <Button
            tag="button"
            @click="updateCurrentPage(tag)"
            theme="text"
            rounded
          >
            {{ tag }}
          </Button>
        </li>
        <li v-if="tag == '...'">
          <span class="elipsis">
            {{ tag }}
          </span>
        </li>
        <li v-if="tag == currentPage">
          <Button tag="button" active rounded>
            {{ tag }}
          </Button>
        </li>
      </template>
      <li v-if="nextButton">
        <Button
          tag="button"
          @click="updateCurrentPage(currentPage + 1)"
          theme="text"
          rounded
        >
          <Icon svg="thinAngleRight" theme="flat" />
        </Button>
      </li>
    </List>
  </div>
</template>
<script>
import Icon from "@/components/ui/atoms/Icon";
import Button from "@/components/ui/atoms/Button";
import List from "@/components/ui/objects/List";
import FormField from "@/components/ui/atoms/FormField";
import { ref } from "vue";
export default {
  components: {
    Button,
    Icon,
    List,
    FormField
  },
  props: {
    total: {
      type: Number,
      default: 0
    },
    itemsPerPage: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 1
    },
    itemsPerPageForm: {
      type: Array,
      default: () => {
        return [
          { text: "5", value: 5 },
          { text: "10", value: 10 },
          { text: "20", value: 20 },
          { text: "50", value: 50 },
          { text: "100", value: 100 }
        ];
      }
    }
  },
  emits: ["updateItemsPerPage", "updateCurrentPage"],
  setup(props, { emit }) {
    const firstPage = 1;
    let totalPages = Math.max(Math.ceil(props.total / props.itemsPerPage), 1);
    const pages = [];

    const currentPage = ref(
      props.total >= props.currentPage * props.itemsPerPage
        ? props.currentPage
        : totalPages
    );
    /* CONSTRUCT TAGS */
    pages.push(firstPage);
    firstPage < currentPage.value - 2 &&
      pages.push(
        currentPage.value - firstPage > 3 ? "..." : currentPage.value - 2
      );
    firstPage < currentPage.value - 1 && pages.push(currentPage.value - 1);
    firstPage != currentPage.value && pages.push(currentPage.value);
    totalPages > currentPage.value + 1 && pages.push(currentPage.value + 1);
    totalPages > currentPage.value + 2 &&
      pages.push(
        totalPages - currentPage.value > 3 ? "..." : currentPage.value + 2
      );
    totalPages != currentPage.value && pages.push(totalPages);
    const prevButton = currentPage.value > firstPage;
    const nextButton = currentPage.value < totalPages;

    const updateItemsPerPage = newItemsPerPage => {
      emit("updateItemsPerPage", newItemsPerPage);
    };

    const updateCurrentPage = newCurrentPage => {
      emit("updateCurrentPage", newCurrentPage);
    };

    return {
      totalPages,
      pages,
      prevButton,
      nextButton,
      updateItemsPerPage,
      updateCurrentPage
    };
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/tools/_mixins.scss";
@use "@/assets/styles/settings/_variables.scss";
.pagination {
  margin: variables.$spacing-s 0;
  display: flex;
  align-items: center;
  .rows {
    margin-right: 1em;
    &:before {
      content: "|";
      margin: 0 1em;
    }
  }
  .numeration {
    display: none;
  }
  .pages-list {
    margin-left: auto;
  }
  .elipsis {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    text-align: center;
    text-decoration: none;
    border: 2px solid transparent;
    border-radius: 0.1rem;
    white-space: nowrap;
    transition: all 0.2s;
    line-height: 1;
    outline: 0;
  }
  button {
    padding: 0;
    width: 32px;
    height: 32px;
    line-height: 32px;
    &-link {
      margin: 2px;
      &:hover,
      &:focus {
        color: variables.$text-inverted-color;
        background: variables.$primary-color;
      }
    }
    &.active {
      color: variables.$text-inverted-color;
      background: variables.$primary-color;
    }
  }
}
@media (min-width: variables.$md) {
  .pagination {
    .numeration {
      display: flex;
      align-items: center;
    }
  }
}
</style>
